/* Stylesheet */

@keyframes fade-in {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.empty_data_container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  animation: fade-in 0.5s ease-in;

  .block_container {
    text-align: center;

    .image {
      height: auto;
      width: 321px;
    }

    .text {
      margin: 32px 0px 0px 0px;
      font-weight: bolder;
      color: var(--ion-color-gray-primary);
    }
  }
}

/* Media Queries */

@media screen and (min-width: 1536px) {
  .empty_data_container {
    .block_container {
      .image {
        height: auto;
        width: 376px;
      }
    }
  }
}
